const ssn = {
    ssn : {
        value: "",
        dbqName: "F[0].Page_1[0].SSN[0]"
     },
     examDate: {
        value: "",
        dbqName: "F[0].Page_1[0].TextField6[0]"
    },
     docName: {
         value: "",
         dbqName: "F[0].Page_5[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "F[0].Page_5[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "F[0].Page_5[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "F[0].Page_5[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "F[0].Page_5[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "F[0].Page_5[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "F[0].Page_5[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].HelicobacterPylori[0].CheckBox36[0]",
            dateDbqName: "F[0].Page_2[0].HelicobacterPylori[0].TextField4[0]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_2[0].TextField6[0]",
            dateDbqName: "F[0].Page_2[0].TextField4[2]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_2[0].TextField6[1]",
            dateDbqName: "F[0].Page_2[0].TextField4[1]",
        }    
    ]

}

export default ssn ;